import * as Sentry from '@sentry/browser';
import hydrate from './hydrate';

const dsn = 'https://6a45b36e61a4431090c20b8434e0ab5e@o173594.ingest.sentry.io/6398871';
if (dsn) {
	Sentry.init({
		dsn,
		environment: process.env.REACT_SENTRY_ENV || 'development',
	});
}

hydrate();
